export default __webpack_public_path__ + "static/media/illustrationRegister2.d8d38886.png";